// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  max-width: 640px;
  margin: 0 auto;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.profile-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-primary);
  margin: 0;
}

/* -- Card ---------------------------------------- */

.profile-card {
  background: var(--color-surface-light);
  border: 1px solid var(--color-surface-dark);
  border-radius: 8px;
  padding: 24px;
}

.profile-card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-primary);
  margin: 0 0 8px;
}

/* -- Info section -------------------------------- */

.profile-info-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-surface-dark);
}

.profile-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--color-secondary);
  color: var(--color-surface-light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 22px;
  flex-shrink: 0;
}

.profile-avatar-name {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-primary);
}

.profile-avatar-email {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-top: 2px;
}

.profile-info-row {
  display: flex;
  padding: 10px 0;
  font-size: 14px;
}

.profile-info-row + .profile-info-row {
  border-top: 1px solid var(--color-surface-dark);
}

.profile-info-label {
  width: 120px;
  flex-shrink: 0;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.profile-info-value {
  color: var(--color-text-primary);
}

/* -- Security section ---------------------------- */

.profile-security-desc {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 16px;
}

/* -- Button -------------------------------------- */

.profile-submit-btn {
  align-self: flex-start;
  padding: 10px 24px;
  background: var(--color-secondary);
  color: var(--color-surface-light);
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.profile-submit-btn:hover {
  background: var(--color-secondary-dark);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,qDAAqD;;AAErD;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qDAAqD;;AAErD;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,qDAAqD;;AAErD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".profile {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.profile-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-primary);\n  margin: 0;\n}\n\n/* -- Card ---------------------------------------- */\n\n.profile-card {\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-surface-dark);\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.profile-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-primary);\n  margin: 0 0 8px;\n}\n\n/* -- Info section -------------------------------- */\n\n.profile-info-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--color-surface-dark);\n}\n\n.profile-avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--color-secondary);\n  color: var(--color-surface-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.profile-avatar-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-primary);\n}\n\n.profile-avatar-email {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-top: 2px;\n}\n\n.profile-info-row {\n  display: flex;\n  padding: 10px 0;\n  font-size: 14px;\n}\n\n.profile-info-row + .profile-info-row {\n  border-top: 1px solid var(--color-surface-dark);\n}\n\n.profile-info-label {\n  width: 120px;\n  flex-shrink: 0;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.profile-info-value {\n  color: var(--color-text-primary);\n}\n\n/* -- Security section ---------------------------- */\n\n.profile-security-desc {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0 0 16px;\n}\n\n/* -- Button -------------------------------------- */\n\n.profile-submit-btn {\n  align-self: flex-start;\n  padding: 10px 24px;\n  background: var(--color-secondary);\n  color: var(--color-surface-light);\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.profile-submit-btn:hover {\n  background: var(--color-secondary-dark);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
